import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-gold/20 bg-ink py-6">
      <div className="animate-marquee flex w-max items-center gap-12 whitespace-nowrap">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-12">
            <span className="font-serif text-lg italic tracking-wide text-ivory/45 sm:text-xl">{item}</span>
            <span className="font-mono text-[10px]" style={{ color: "#C8564D" }} aria-hidden="true">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
